import React, { useState, useEffect } from 'react';
import { auth } from '../../firebase';
import { signOut } from "@firebase/auth";
import { Link } from 'react-router-dom';
import './login_signup.css';

function AdminPage() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(false);
  }, []);

  const handleLogout = async () => {
    await signOut(auth);
    window.location.href = '/';
  };

  if (loading) {
    return (
      <div className="admin-login-bg">
        <div className="admin-login-card">
          <div className="admin-login-loading">
            <div className="admin-login-spinner"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-login-bg">
      <div className="admin-login-card">
        <h1 className="admin-login-title">Admin Portal</h1>
        <div style={{ marginBottom: "1.5rem" }}>
          <p style={{ fontSize: "1.1rem", color: "#374151", fontWeight: 500 }}>
            Welcome to the admin dashboard. Use the options below to manage tournaments.
          </p>
        </div>
        <div style={{ marginBottom: "1rem" }}>
          <Link to="/admin/createTournament">
            <button className="admin-login-btn" type="button">
              Create New Tournament
            </button>
          </Link>
        </div>
        <div style={{ marginBottom: "1rem" }}>
          <Link to="/admin/listTournaments">
            <button className="admin-login-btn" type="button">
              View/Edit Tournaments
            </button>
          </Link>
        </div>
        <div style={{ marginBottom: "1rem" }}>
          <Link to="/admin/listGolfCourses">
            <button className="admin-login-btn" type="button">
              View/Edit Golf Courses
            </button>
          </Link>
        </div>
        <div style={{ marginBottom: "1rem" }}>
          <Link to="/admin/tournamentsByUser">
            <button className="admin-login-btn" type="button">
              See Tournaments Added per User
            </button>
          </Link>
        </div>
        <div style={{ marginBottom: "1rem" }}>
          <Link to="/admin/tournamentsByUserChallenge">
            <button className="admin-login-btn" type="button">
              2 day challenge: Tournaments Created by User<br />7/17/25 12PM PT – 7/19/25 12PM PT
            </button>
          </Link>
        </div>
        <button
          className="admin-login-btn"
          style={{ background: "linear-gradient(90deg, #ef4444 0%, #f87171 100%)", marginTop: "0.5rem" }}
          onClick={handleLogout}
        >
          Logout
        </button>
      </div>
    </div>
  );
}

export default AdminPage;